<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">


    <Slick ref="slick" :options="slickOptions" class="slick-item" v-if="false">
      <div><a href="https://blog.yagish.jp/entry/2023/01/04/174328?utm_source=blogWidget" target="_blank"><img
            src="/kr/resume/static/renew_img/bnr/mypage_top_banner_20230116.png"></a></div>
    </Slick>
    <section class="flex">
      <article class="content-wrapper" v-if="$firebase.isAuthenticated">
        <div class="content-wrapper" style="padding-bottom: 0px !important;">
          <h2>당신의 이력서</h2>
          <ul class="timeline">
            <li v-for="(backup, index) in backupList['user'].slice(0, 1)" :key="index">
              <div class="btn_wrapper" v-if="index == 0">
                <p class="date">{{ $formLib.dateFormat(backup.value.timestamp, 'yyyy년mm월dd일HH시MM분') }}</p>
                <p class="os">{{ backup.value.platform }}::{{ index }}</p>
                <a class=" btn_cta" @click.prevent="confirmBackup(backup)">이력서선택 <span>(미리보기)</span></a>
              </div>
            </li>
          </ul>
          <section id="more">
            <input id="acd-title-more" class="acd-check-more" type="checkbox">
            <label class="acd-label-more" for="acd-title-more">더보기 ▼</label>
            <div class="acd-content-more">
              <ul class="timeline">
                <li v-for="(backup, index) in backupList['user'].slice(1)" :key="index">
                  <div class="circle"></div>
                  <div class="vertical-line"></div>
                  <div class="btn_wrapper">
                    <p class="date">{{ $formLib.dateFormat(backup.value.timestamp, 'yyyy년mm월dd일HH시MM분') }} 변경</p>
                    <p class="os">{{ backup.value.platform }}</p>
                    <a class=" btn_cta" @click.prevent="confirmBackup(backup)">이력서선택 <span>(미리보기)</span></a>
                  </div>
                </li>
              </ul>
            </div>
          </section>
          <div class="btn_wrapper">
            <div class="btn_backup" v-if="false">
              <el-button :disabled="saved" type="success" @click="saveBackup">백업생성</el-button>
            </div>
            <router-link v-if="recentEdit.FormatId !== ''"
              :to="{ name: 'formatEditCard', params: { formatId: recentEdit.FormatId, cardId: recentEdit.cardId } }"
              v-ripple class="btn_cta">계속해서 입력
            </router-link>
          </div>
        </div>
      </article>
      <article v-else class="content-wrapper">
        <div class="action">
          <p>백업에는 로그인이 필요합니다.</p>
          <login-forms />
        </div>
      </article>
    </section>
    <!-- <iframe src="https://stg-rirekisho.yagish.jp/cvtest"
      height="0" width="0"  v-if="getMode != 'production'"></iframe> -->



    <div class="content-wrapper">
      <a href="https://lin.ee/0rfNtli" target="_blank"><img src="/kr/resume/static/renew_img/banner_line.png"
          class="banner-line sp"></a>
    </div>



    <section class="banner-contents" v-if="false">
      <ul class="banner-box">
        <li>
          <a href="https://bit.ly/39KLMRh" target="_blank"><img
              src="/kr/resume/static/renew_img/bnr/mypage_middle_banner_20211229_001.png" class="banner"></a>
        </li>
      </ul>
    </section>




    <modal name="confirm-backup-dialog" :adaptive="true" :scrollable="true" height="auto"
      @opened="setPreviewScale(); previewLoading = false">
      <div class="v--modal-close-top">
        <el-button @click="closeDialog" icon="el-icon-close" type="text"></el-button>
      </div>
      <div v-if="backupDataToConfirm" class="backup-preview-dialog">
        <div class="formats-info">
          <div class="title">
            <p v-if="false">{{ formattedBackupData.label }}</p>
          </div>
          <div class="date">{{ $formLib.dateFormat(formattedBackupData.lastSaveDate, 'yyyy년mm월dd일HH시MM분') }}</div>
          <div class="system">{{ formattedBackupData.platform }}</div>
        </div>
        <el-tabs v-model="activePreviewTab" class="backup-tabs" :stretch="true"
          @tab-click="setPreviewScale(); previewLoading = false">
          <el-tab-pane label="이력서" name="format_rirekisho" :lazy="true" :style="backupDataViewerCssRirekisho">
            <rirekisho-preview ref="backupDataViewer" :id-prefix="'backup'"
              :format-data="formattedBackupData.format_rirekisho" :basic-data="formattedBackupData.basicData"
              :preview-scale="previewScale"></rirekisho-preview>
          </el-tab-pane>
          <el-tab-pane label="경력기술서" name="format_shokumukeirekisho" v-if="false" :lazy="true"
            :style="backupDataViewerCssShokurekisho">
            <shokurekisho-preview ref="backupDataViewer" :id-prefix="'backup'"
              :format-data="formattedBackupData.format_shokumukeirekisho" :basic-data="formattedBackupData.basicData"
              :preview-scale="previewScale"></shokurekisho-preview>
          </el-tab-pane>
          <el-tab-pane label="송장" name="format_letter" :lazy="true" v-if="false" :style="backupDataViewerCssRirekisho">
            <letter-preview ref="backupDataViewer" :id-prefix="'backup'"
              :format-data="formattedBackupData.format_letter" :basic-data="formattedBackupData.basicData"
              :preview-scale="previewScale"></letter-preview>
          </el-tab-pane>
        </el-tabs>
        <!-- </br> -->
        <div class="delete delete-confirm" v-if="!deleteBackupPopoverVisible">
          <div class="delete-text-button">
            <el-button @click="deleteBackupPopoverVisible = true" type="text" icon="el-icon-delete">백업삭제</el-button>
          </div>
        </div>
        <div class="delete delete-confirm" v-else>
          <div style="text-align: right; margin: 0">
            <el-button @click="deleteBackupPopoverVisible = false">취소</el-button>
            <el-button @click="deleteBackup(backupDataToConfirm)" type="danger"><i
                class="el-icon-delete"></i>삭제</el-button>
          </div>
          <p>삭제하면 원래대로 되돌릴 수 없으니 주의 해주세요.</p>
        </div>
      </div>

      <div class="text-right">
        <el-button type="primary" @click="loadBackup(backupDataToConfirm)">복원</el-button>
        <el-button @click="closeDialog">닫기</el-button>
      </div>
      <br /><br />
    </modal>
    <section class="btn_top"><a class="btn_sub" href="/kr/resume/">메인으로</a></section>

    <section id="setting" v-if="$firebase.isAuthenticated">
      <div class="content-wrapper">
        <input id="acd-title" class="acd-check" type="checkbox">
        <label class="acd-label" for="acd-title">설정<img src="/kr/resume/static/renew_img/icon_setting.svg"></label>
        <div class="acd-content">
          <div class="delite">
            <a href="/kr/resume/account/delete" class="btn_green">데이터・계정삭제</a>
            <p>브라우저데이터나 서버백업 데이터, 등록 계정을 삭제할 수 있습니다.</p>
          </div>
          <div class="logout">
            <el-button id="google-logout-account-dialog"
              @click="$firebase.signOut(); $event.preventDefault()">로그아웃</el-button>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>
<style lang="scss" src="@/assets/scss/formats.scss"></style>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style scoped>
@import "/static/css/slick-theme.css";
@import "/static/css/slick.css";
</style>

<style scoped>
.offer_status {
  background: #404040;
  border-radius: 30px;
  padding: 3px 20px;
  color: #fff;
  margin-right: 5px;
  margin-bottom: 5px;
}

.status_approved {
  background: #E95B10;
}

.status_decline {
  background: #DFDFDF;
}

.offer_list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.offer_company {
  font-size: 1rem;
  font-weight: bold;
  margin-right: 10px;
}

.offer_view {
  padding: 5px;
  border-radius: 30px;
  background: #0F9934;
  color: #fff;
  margin-right: 5px;
}

.offer_view_btn {
  background: #fff;
}

.offer_view_txt {
  font-size: 0.7rem;
  color: #0F9934;
}



.tooltip5 {
  position: relative;
  cursor: pointer;
  display: inline-block;
}

.offer_flex {
  display: flex;
  align-items: center;
}

.tooltip5 img {
  width: 50px;
  height: 50px;
  margin-left: 10px;
  filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.2));
}

.description5 {
  display: none;
  position: absolute;
  padding: 10px 15px;
  font-size: 12px;
  line-height: 1.6em;
  color: #404040;
  border-radius: 5px;
  background: #FFFFE9;
  width: 300px;
  text-align: left;
}

.description5:before {
  content: "";
  position: absolute;
  top: 100%;
  right: 14%;
  border: 15px solid transparent;
  border-top: 15px solid #FFFFE9;
  margin-left: -15px;
}

.tooltip5:hover .description5 {
  display: inline-block;
  bottom: 90px;
  right: -35px;
}

.quickemail_status {
  background: #404040;
  border-radius: 30px;
  padding: 3px 20px;
  color: #fff;
  margin-right: 5px;
  margin-bottom: 5px;
  font-size: 0.8rem;
}

.status_unread {
  background: #E95B10;
}

.status_read {
  background: #DFDFDF;
}

.quickemail_list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.quickemail_company {
  font-size: 1rem;
  font-weight: bold;
  margin-right: 10px;
}

.quickemail_view {
  padding: 5px;
  border-radius: 30px;
  background: #0F9934;
  color: #fff;
  margin-right: 5px;
}

.quickemail_view_btn {
  background: #fff;
}

.quickemail_view_txt {
  font-size: 0.7rem;
  color: #0F9934;
}

.quickemail_flex {
  align-items: center;
}

.quickemail_date {
  margin-right: 10px;
}

.formats-info_rirekisyo {
  background: #EFF8F8;
  padding: 15px;
  margin: 10px 0;
  border-radius: 5px;
}

.formats-info_rirekisyo-small {
  font-size: 0.7rem;
  opacity: 0.5;
}
</style>

<script>
import {
  TabPane,
  Tabs,
  MessageBox
} from 'element-ui'
// import RirekishoPreview from '@/components/formats/RirekishoPreview'
import RirekishoPreview from '@/components/formats/DesignRirekisho001Preview'
import ShokurekishoPreview from '@/components/formats/ShokurekishoPreview'
import LetterPreview from '@/components/formats/LetterPreview'
import LoginForms from '@/components/RenewLoginForms'
import Slick from 'vue-slick'
import firebase from 'firebase/app'

const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
export default {
  components: {
    'rirekisho-preview': RirekishoPreview,
    'shokurekisho-preview': ShokurekishoPreview,
    'letter-preview': LetterPreview,
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    'login-forms': LoginForms,
    Slick
  },
  data: function () {
    return {
      fullscreenLoading: true,
      recentEdit: {
        FormatId: ''
      },
      introData: {},
      backupList: {
        auto: [],
        user: []
      },
      dialogVisible: false,
      selectedYagiOfferData: {},
      selectedQuickEmailData: {},
      yagiOfferData: [],
      quickemailList: [],
      qmail_rirekisho_html: '',
      qmail_shokumukeirekisho_html: '',
      backupListLoaded: {
        auto: false,
        user: false
      },
      slickOptions: {
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 2400,
        speed: 400
      },
      saved: false,
      recomm_code: '',
      saveLabel: '',
      backupDataToConfirm: null,
      previewScale: 1,
      previewQEmailScale: 1,
      backupDataViewerCssRirekisho: {},
      backupDataViewerCssShokurekisho: {},
      qmailViewerCssRirekisho: {},
      qmailViewerCssShokurekisho: {},
      deleteBackupPopoverVisible: false,
      previewLoading: false,
      rirekisho_height: 110,
      keirekisho_height: 110,
      previewQEmailLoading: false,
      activeTabName: 'user',
      activePreviewTab: 'format_rirekisho',
      activeQEmailPreviewTab: 'format_rirekisho'
    }
  },
  computed: {
    formattedBackupData: function () {
      if (!this.backupDataToConfirm) return {}
      const content = JSON.parse(this.backupDataToConfirm.value.content)
      console.error(content)
      return {
        lastSaveDate: this.backupDataToConfirm.value.lastSaveDate,
        label: this.backupDataToConfirm.value.label,
        format_rirekisho: content.format_rirekisho || {},
        format_shokumukeirekisho: content.format_shokumukeirekisho || {},
        format_letter: content.format_letter || {},
        basicData: content.basicData || {},
        platform: this.backupDataToConfirm.value.platform
      }
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    scaleQEmailStyle: function () {
      const _style = {
        'transform': 'scale(' + this.previewQEmailScale + ')',
        'transform-origin': 'top left',
        'height': (this.rirekisho_height * this.previewQEmailScale)
      }
      return _style
    }
  },
  methods: {
    setPreviewScale: function () {
      this.$nextTick(function () {
        if (this.$refs.backupDataViewer.$el.clientWidth === 0) {
        } else {
          const clientWidth = this.$refs.backupDataViewer.$el.clientWidth
          this.previewScale = clientWidth / Math.max(clientWidth, DOC_PAPER_HEIGHT_PX)
          // console.log(clientWidth, this.previewScale)
        }
        this.$nextTick(function () {
          this.setPreviewHeight()
        })
      })
    },
    setQEmailPreviewScale: function () {
      this.$nextTick(function () {

        if (this.activeQEmailPreviewTab === 'format_rirekisho') {
          if (this.$refs.rirekisho_pane.clientWidth === 0) {
          } else {
            const clientWidth = this.$refs.rirekisho_pane.clientWidth
            this.previewQEmailScale = clientWidth / Math.max(clientWidth, DOC_PAPER_HEIGHT_PX)
          }
        } else if (this.activeQEmailPreviewTab === 'format_shokumukeirekisho') {
          if (this.$refs.shokumukeirekisho_pane.clientWidth === 0) {
          } else {
            const clientWidth = this.$refs.shokumukeirekisho_pane.clientWidth
            this.previewQEmailScale = clientWidth / Math.max(clientWidth, DOC_PAPER_HEIGHT_PX)
          }
        }
        this.$nextTick(function () {
          this.setQEmailPreviewHeight()
        })
      })
    },
    sendThank: function (intro_detail_id) {
      const app = this
      const formData = new FormData()
      console.error(intro_detail_id)
      formData.append('intro_detail_id', intro_detail_id)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')

      this.$axios
        .post(this.$varuna.endPoints.sendIntroductionThank, formData, { timeout: 60000 })
        .then(function (response) {
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `메일전송성공`,
            type: 'success'
          })
        })
        .catch(function (error) {
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `메일전송실패`,
            type: 'error'
          })

        }).finally(function () {

        })
    },
    updDisplayFlag: function (intro_detail_id, displayFlag) {
      const app = this
      const formData = new FormData()
      console.error(intro_detail_id)
      formData.append('intro_detail_id', intro_detail_id)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('display_flag', displayFlag)
      formData.append('version', '2')
      formData.append('reqflg', '2')

      this.$axios
        .post(this.$varuna.endPoints.updateIntroductionDisplay, formData, { timeout: 60000 })
        .then(function (response) {
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `성공하였습니다.`,
            type: 'success'
          })
          app.$axios
            .post(app.$varuna.endPoints.getIntroduction, formData, { timeout: 60000 })
            .then(function (response) {
              app.introData = response.data
            })
            .catch(function (error) {
            }).finally(function () {

            })
        })
        .catch(function (error) {
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `실패하였습니다.`,
            type: 'error'
          })

        }).finally(function () {

        })
    },
    setPreviewHeight: function () {
      const height = this.$refs.backupDataViewer.$refs.previewMain.getBoundingClientRect().height
      // const height = 10
      if (!height) {
        return
      }
      if (this.activePreviewTab === 'format_rirekisho' && height > 0) {
        this.backupDataViewerCssRirekisho = {
          height: height + 30 + 'px'
        }
      } else if (this.activePreviewTab === 'format_shokumukeirekisho' && height > 0) {
        this.backupDataViewerCssShokurekisho = {
          height: height + 30 + 'px'
        }
      }
    },
    setQEmailPreviewHeight: function () {
      const height = this.$refs.rirekisho_pane.getBoundingClientRect().height
      // const height = 10
      if (!height) {
        return
      }

      if (this.activeQEmailPreviewTab === 'format_rirekisho' && height > 0) {
        this.qmailViewerCssRirekisho = {
          height: height + 30 + 'px'
        }
        this.rirekisho_height = height + 30
      } else if (this.activeQEmailPreviewTab === 'format_shokumukeirekisho' && height > 0) {
        this.qmailViewerCssShokurekisho = {
          height: height + 30 + 'px'
        }
        this.keirekisho_height = height + 30
      }
    },
    openDialog: function () {
      this.$modal.show('confirm-backup-dialog')
      this.backupDataViewerCssRirekisho = {}
      this.backupDataViewerCssShokurekisho = {}
    },
    closeDialog: function () {
      this.$modal.hide('confirm-backup-dialog')
      this.deleteBackupPopoverVisible = false
    },
    confirmBackup: function (backup) {
      // console.log(backup)
      this.backupDataToConfirm = backup
      this.previewLoading = true
      this.openDialog()
    },
    openQuickemailCancelModal: function () {
      this.$modal.hide('qemail-detail-dialog')

      this.$modal.show('qemail-cancel-confirm-dialog')
    },
    cancelQuickemail: function () {
      const app = this
      const formData = new FormData()
      formData.append('history_id', this.selectedQuickEmailData.history_id)
      formData.append('uuid', this.$firebase.user.uid)

      this.$axios
        .post(this.$varuna.endPoints.cancelQuickemail, formData, { timeout: 60000 })
        .then(function (response) {
          app.$message({
            message: '전송취소를 완료 하였습니다.',
            type: 'info'
          })
          app.selectedQuickEmailData.cancel_flag = '1'
          app.$modal.hide('qemail-cancel-confirm-dialog')
        })
        .catch(function (error) { })
        .finally(function () { })
    },
    setDefaultSaveLabel: function () {
      if (this.$yagi.profile.name) {
        this.saveLabel = this.$yagi.profile.name + '의 백업'
      } else {
        this.saveLabel = '백업'
      }
    },
    saveBackup: function () {
      if (this.$yagi.profile.name) {
        this.saveLabel = this.$yagi.profile.name + '의 백업'
      } else {
        this.saveLabel = '백업'
      }
      this.$firebase.addBackup(this.saveLabel, 'user')
      this.loadBackupList('user')
      this.saved = true
    },
    loadBackupList: function (type) {
      const app = this
      app.backupListLoaded[type] = false
      app.backupList[type] = []
      app.$firebase.getBackupList('all', 5)
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            app.backupList[type].push({
              id: doc.id,
              value: doc.data()
            })
          })
          app.backupListLoaded[type] = true
        })
        .catch(function (err) {
          console.error(err)
        })
    },
    loadBackup: function (backup) {
      this.$firebase.loadBackup(backup.id)
      this.closeDialog()
    },
    deleteBackup: function (backup) {
      this.$firebase.deleteBackupWithMessage(backup.id, backup.value.label)
      console.log('deleteBackup', backup)
      this.getBackups(true)
      this.closeDialog()
    },
    openYagiOfferDetailDialog: function (idx) {
      this.$modal.show('offer-detail-dialog')
      this.selectedYagiOfferData = this.yagiOfferData.offer_list[idx]
      console.error(this.selectedYagiOfferData)
      if (this.selectedYagiOfferData.read_flag != '1') {
        const app = this
        const formData = new FormData()
        formData.append('offer_id', this.selectedYagiOfferData.offer_id)
        formData.append('uuid', this.$firebase.user.uid)

        this.$axios
          .post(this.$varuna.endPoints.readYagiOffer, formData, { timeout: 60000 })
          .then(function (response) { })
          .catch(function (error) { })
          .finally(function () { })
      }
    },
    openQuickEmailDetailDialog: function (idx) {
      this.$modal.show('qemail-detail-dialog')
      this.selectedQuickEmailData = this.quickemailList.qemail_list[idx]
      console.error(this.selectedQuickEmailData)
      this.qmail_rirekisho_html = this.selectedQuickEmailData.rirekisho_html
      this.qmail_shokumukeirekisho_html = this.selectedQuickEmailData.keirekisho_html
      this.qmailViewerCssRirekisho = {}
      this.qmailViewerCssShokurekisho = {}
    },
    dataChanged: function () {
      this.saved = false
      this.setDefaultSaveLabel()
    },
    submitOffer: function () {
      const app = this
      const formData = new FormData()
      formData.append('offer_id', this.selectedYagiOfferData.offer_id)
      formData.append('uuid', this.$firebase.user.uid)

      this.$axios
        .post(this.$varuna.endPoints.submitYagiOffer, formData, { timeout: 60000 })
        .then(function (response) {
          for (let _item of app.yagiOfferData.offer_list) {
            if (app.selectedYagiOfferData.offer_id == _item.offer_id) {
              _item.offer_status = 'accept'
            }
          }
          app.$message({
            duration: 3000,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `오퍼를 수락 하였습니다.`,
            type: 'success'
          })
        })
        .catch(function (error) {
          app.$message({
            duration: 3000,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `오퍼 수락처리를 실패 하였습니다.`,
            type: 'error'
          })
        }).finally(function () {

        })
      console.error(this.selectedYagiOfferData.offer_id)
    },
    denyOffer: function () {
      const app = this
      const formData = new FormData()
      formData.append('offer_id', this.selectedYagiOfferData.offer_id)
      formData.append('uuid', this.$firebase.user.uid)

      this.$axios
        .post(this.$varuna.endPoints.denyYagiOffer, formData, { timeout: 60000 })
        .then(function (response) {
          for (let _item of app.yagiOfferData.offer_list) {
            if (app.selectedYagiOfferData.offer_id == _item.offer_id) {
              _item.offer_status = 'refuse'
            }
          }
          app.$message({
            duration: 3000,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `오퍼를 거절 하였스니다.`,
            type: 'success'
          })
        })
        .catch(function (error) {
          app.$message({
            duration: 3000,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `오퍼 거절처리를 실패 하였습니다.`,
            type: 'error'
          })
        }).finally(function () {

        })
      console.error(this.selectedYagiOfferData.offer_id)
    },
    loadRecentEdit: function () {
      const app = this
      this.$getItem(RECENT_EDIT_SAVE_KEY, function (err, data) {
        if (err) {
          console.log(err)
        }
        if (data) {
          app.recentEdit = data
        }
      })
    },
    getBackups: function (force) {
      if (this.$deviceLib.isOnline && this.$firebase.isAuthenticated) {
        if (force) {
          this.loadBackupList('auto')
          this.loadBackupList('user')
        } else {
          if (!this.backupListLoaded['user']) {
            this.loadBackupList('user')
          }
          if (!this.backupListLoaded['auto']) {
            this.loadBackupList('auto')
          }
        }
      }
    }
  },
  created: function () {
    const app = this
    // console.log(this.$route.query.mynavi)
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        console.log('logined')
        const formData = new FormData()
        formData.append('access_id', '')
        formData.append('uuid', user.uid)
        formData.append('device_flg', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')
        formData.append('version', '2')
        formData.append('reqflg', '2')

        this.$axios
          .post(this.$varuna.endPoints.getIntroduction, formData, { timeout: 60000 })
          .then(function (response) {
            app.introData = response.data
            app.recomm_code = "/recomm_preview/" + response.data.access_id
          })
        this.$axios
          .post(this.$varuna.endPoints.getYagiOfferList, formData, { timeout: 60000 })
          .then(function (response) {
            app.yagiOfferData = response.data
          })
        this.$axios
          .post(this.$varuna.endPoints.getQuickemailList, formData, { timeout: 60000 })
          .then(function (response) {
            app.quickemailList = response.data
          })
        this.fullscreenLoading = false

      } else {
        this.$router.push('/login')
      }
    })
    this.loadRecentEdit()
  },
  beforeMount: function () {
    this.$eventHub.$on('basic-data-changed', this.dataChanged)
    this.$eventHub.$on('format-data-changed', this.dataChanged)
    this.$eventHub.$on('firebase-initialized', this.getBackups)
    this.$eventHub.$on('yagi-profile-loaded', this.setDefaultSaveLabel)
    this.$eventHub.$on('yagi-profile-saved', this.setDefaultSaveLabel)
    this.setDefaultSaveLabel()
    this.getBackups()
  },
  destroyed: function () {
    this.$eventHub.$off('basic-data-changed', this.dataChanged)
    this.$eventHub.$off('format-data-changed', this.dataChanged)
    this.$eventHub.$off('firebase-initialized', this.getBackups)
    this.$eventHub.$off('yagi-profile-loaded', this.setDefaultSaveLabel)
    this.$eventHub.$off('yagi-profile-saved', this.setDefaultSaveLabel)
  }
}
</script>
